import { Button, Form, Input, InputNumber, Select, Space, Switch } from 'antd';
import { useContext, useEffect, useState } from 'react';
import getList from '../universal/getList';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import fetchApi from '../../utils/api/fetchApi';
import systemConfig from '../../config/systematic';
import { SocketContext } from '../../App';

//  主配料formList通用组件
export default function WebIngredientFormList(props: any) {

    const { formName, dataName, isBase, ingredient, ingredientLength, tempDeleteData, parentData, monthsBack, refreshData } = props;
    const { form, type, ref, setIngredientDetailData, setTempDeleteData, setPersent, setRefreshData } = props.props;

    // const formListData = Form.useWatch(formName, form) as any;

    /**产品数据 */
    const [productData, setProductData] = useState<any>();

    /**产品单位数据 */
    const [productUnitData, setProductUnitData] = useState<any>();

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    await setBaseData(res);
                }
            })
        }

        if (type === 'COPY') {
            fetchApi.GET(wmService, {
                apiId: "menuWarehouseIngredient",
                apiExtend: "showSingle",
                apiVariable: parentData.id,
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isBranchStore: true
                        }
                    }
                }
            }).then(async res => {
                if (res.success) {
                    await setBaseData(res);
                }
            });
        }

        const fetchData = async () => {
            if (type === 'COPY') {
                await fetchApi.GET(wmService, {
                    apiId: "menuWarehouseIngredient",
                    apiExtend: "showSingle",
                    apiVariable: parentData.id,
                    apiData: {
                        mountDataOptions: {
                            userMount: {
                                isBranchStore: true
                            }
                        }
                    }
                }).then(async res => {
                    if (res.success) {
                        await setBaseData(res);
                    }
                });
            }

            fetchApi.GET(wmService, {
                apiId: "productUnit",
                apiExtend: 'showList'
            }).then(res => {
                setProductUnitData(res.data);
            });
        }
        fetchData()
    }, [])

    const setBaseData = async (res: any) => {
        let ingredientObj: any = {};
        let ingredientObj1: any = {};
        //自定义formList数据初始状态
        let newData: Array<any> = [];

        // console.log("---------------------返回的数据------------------------");
        // console.log(res.data);

        if (isBase) {
            for (var i = 0; i < res.data.rowsDetail[ingredient].length; i++) {
                ingredientObj[i] = [res.data.rowsDetail[ingredient][i].product];
                ingredientObj1[i] = [res.data.rowsDetail[ingredient][i].productUnit];

                if (type !== "NEW") {
                    newData.push({
                        id: res.data.rowsDetail[ingredient][i].id,
                        ingredientId: res.data.rowsDetail[ingredient][i].ingredientId,
                        productId: res.data.rowsDetail[ingredient][i].productId,
                        amounts: res.data.rowsDetail[ingredient][i].amounts,
                        productUnitId: res.data.rowsDetail[ingredient][i].productUnitId,
                        yieldRatio: res.data.rowsDetail[ingredient][i].yieldRatio,
                        unitPrice: res.data.rowsDetail[ingredient][i].unitPrice,
                        totals: res.data.rowsDetail[ingredient][i].totals,
                        autoUpdate: res.data.rowsDetail[ingredient][i].autoUpdate,
                        baseUnitPrice: res.data.rowsDetail[ingredient][i].unitPrice,
                        memo: res.data.rowsDetail[ingredient][i].memo,
                        conversionFactor: res.data.rowsDetail[ingredient][i].conversionFactor,
                        state: "origin"
                    })
                }
            }

            // console.log(ingredientObj);
            // console.log("ingredientObj");
            // console.log(ingredientObj1[0] ? ingredientObj1 : "1");
            // console.log("newData", newData);

            form.setFieldsValue({ [formName]: newData });

            setProductData(ingredientObj);
            setProductUnitData(ingredientObj1);
        }
    };

    const mergeIngredientDetail = (ingredientLength: any, delData?: any) => {
        let ingredientDetail: any;
        let costPrices: any = 0;

        for (var i_data = 0; i_data < ingredientLength; i_data++) {
            let str_data = "ingredientDetail" + i_data;

            if (ingredientDetail) {
                if (form.getFieldsValue()[str_data]) {
                    ingredientDetail = ingredientDetail.concat(form.getFieldsValue()[str_data]);
                }
            }
            else {
                ingredientDetail = form.getFieldsValue()[str_data];
            }
        }

        // 计算总成本价格
        for (var i_costPrices = 0; i_costPrices < ingredientDetail.length; i_costPrices++) {
            costPrices = Number(costPrices) + Number(ingredientDetail[i_costPrices].totals !== undefined ? ingredientDetail[i_costPrices].totals : 0);
        }

        // console.log("------------------合并时，收到需要删除的数据------------------");
        // console.log(delData);

        if (delData) {
            ingredientDetail = ingredientDetail.concat(delData);
        }

        // console.log("------------------最后的总数据------------------");
        // console.log(ingredientDetail);

        setIngredientDetailData(ingredientDetail);
        form.setFieldsValue({ costPrices: costPrices.toFixed(3) });
        setPersent(form, form.getFieldValue("sellPrice"));
    };

    if (refreshData) {
        // console.log("------------refreshData----------------");
        mergeIngredientDetail(ingredientLength, tempDeleteData);
        setRefreshData(false);
    }

    //remove 删除
    const removeList = (remove: Function, num: number, key: number, originData: any) => {

        //即将删除的数据
        let removeData = form.getFieldsValue()[formName][num];
        let concatData: any;

        if (removeData && removeData.id) {

            let addDeleteData: any;
            addDeleteData = { ...removeData, state: "delete" };

            if (originData) {
                originData.push(addDeleteData);
                concatData = originData;
            }
            else {
                let tmpData: any = [];
                tmpData.push(addDeleteData);
                concatData = tmpData;
            }

            setTempDeleteData(concatData);
        }
        else {
            if (originData) {
                concatData = originData;
            }

            setTempDeleteData(concatData);
        }

        remove(num);
        mergeIngredientDetail(ingredientLength, concatData);

        if (productData) {
            delete productData[key];
        }
    }

    const customizeAdd = (add: Function, ingredient: any, originData: any) => {
        add();
        form.setFieldValue([formName, form.getFieldsValue()[formName].length - 1], { ingredientId: ingredient, state: "insert" });
        mergeIngredientDetail(ingredientLength, originData);
    }

    /**将修改的内容的状态改为update 并和 需要删除的数据进行合并*/
    const handleChange = async (form: any, e: any, name?: any, FormListName?: string, type?: string, originData?: any, key?: any) => {
        if (key === 'productId') {
            //获取该原材料信息，把单位自动填入
            await fetchApi.GET(wmService, {
                apiId: "product",
                apiExtend: "showListForIngredient",
                apiData: {
                    productId: e,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    },
                }
            }).then((res) => {
                form.setFieldValue([FormListName, name, "productUnitId"], res.data[0].productUnitId);
            })

            //获取该原材料价格信息，把单价自动填入
            await fetchApi.GET(wmService, {
                apiId: "product",
                apiExtend: "purPrice",
                apiData: {
                    productId: e,
                    // branchStoreId: contextData?.currentBranchStoreId,
                    areaId: contextData?.currentAreaId,
                    monthsBack
                }
            }).then((res) => {
                form.setFieldValue([FormListName, name, "autoUpdate"], true);
                form.setFieldValue([FormListName, name, "unitPrice"], res.data === -1 ? 0 : res.data);
                form.setFieldValue([FormListName, name, "baseUnitPrice"], res.data === -1 ? 0 : res.data);
            })
        }

        if (key === 'productUnitId') {
            if (type !== "NEW") {
                //获取该原材料价格信息，把单价自动填入
                await fetchApi.GET(wmService, {
                    apiId: "product",
                    apiExtend: "purPrice",
                    apiData: {
                        productId: form.getFieldValue([FormListName, name, "productId"]),
                        // branchStoreId: contextData?.currentBranchStoreId,
                        areaId: contextData?.currentAreaId,
                        monthsBack
                    }
                }).then((res) => {
                    form.setFieldValue([FormListName, name, "baseUnitPrice"], res.data === -1 ? 0 : res.data);
                })
            }
            if (form.getFieldValue([FormListName, name, "productId"])) {
                //获取根据所选择的单位，查找是否有匹配的数据;如果有数据则进行换算并自动填入，如无则用原来的数据
                await fetchApi.GET(wmService, {
                    apiId: "unitConversion",
                    apiExtend: "showUnitConversion",
                    apiData: {
                        productUnitId: e,
                        productId: form.getFieldValue([FormListName, name, "productId"])
                    }
                }).then((res) => {
                    if (res.success) {
                        if (res.data.length === 1) {
                            form.setFieldValue([FormListName, name, "isUnitConversion"], true);
                            form.setFieldValue([FormListName, name, "autoUpdate"], true);
                            form.setFieldValue([FormListName, name, "unitConversionPrice"], form.getFieldValue([FormListName, name, "baseUnitPrice"]) / res.data[0].conversionFactor);
                            form.setFieldValue([FormListName, name, "unitPrice"], form.getFieldValue([FormListName, name, "baseUnitPrice"]) / res.data[0].conversionFactor);
                            form.setFieldValue([FormListName, name, "conversionFactor"], res.data[0].conversionFactor);
                        }
                        else {
                            form.setFieldValue([FormListName, name, "isUnitConversion"], false);
                            form.setFieldValue([FormListName, name, "autoUpdate"], true);
                            form.setFieldValue([FormListName, name, "conversionFactor"], null);
                            form.setFieldValue([FormListName, name, "unitPrice"], form.getFieldValue([FormListName, name, "baseUnitPrice"]));
                        }
                    }
                })
            }
        }

        // let amounts = form.getFieldValue([FormListName, name, "amounts"]);
        // let yieldRatio = form.getFieldValue([FormListName, name, "yieldRatio"]);
        // let unitPrice = form.getFieldValue([FormListName, name, "unitPrice"]);

        // let newTotalPrice = Number(amounts) * Number(unitPrice) / Number(yieldRatio) * 100;

        // //设置总价格
        // form.setFieldValue([FormListName, name, "totals"], newTotalPrice.toFixed(3));

        await totalize(form, name, FormListName, type, originData);

        // if (type === "EDIT") {
        //     form.setFieldValue([FormListName, name], { ...form.getFieldsValue()[FormListName!][name], state: form.getFieldsValue()[FormListName!][name].id ? "update" : "insert" })
        // }
        // mergeIngredientDetail(ingredientLength, originData);
    }

    const totalize = (form: any, name?: any, FormListName?: string, type?: string, originData?: any) => {

        let amounts = form.getFieldValue([FormListName, name, "amounts"]);
        let unitPrice = form.getFieldValue([FormListName, name, "unitPrice"]);
        let yieldRatio = form.getFieldValue([FormListName, name, "yieldRatio"]);
        let baseUnitPrice = form.getFieldValue([FormListName, name, "baseUnitPrice"]);
        let isUnitConversion = form.getFieldValue([FormListName, name, "isUnitConversion"]);
        let unitConversionPrice = form.getFieldValue([FormListName, name, "unitConversionPrice"]);

        if (!isUnitConversion) {
            if (unitPrice !== baseUnitPrice) {
                form.setFieldValue([FormListName, name, "autoUpdate"], false);
            }
        }
        else {
            if (unitPrice !== unitConversionPrice) {
                form.setFieldValue([FormListName, name, "autoUpdate"], false);
            }
        }

        let newTotalPrice = Number(amounts) * Number(unitPrice) / Number(yieldRatio) * 100;

        //设置总价格
        form.setFieldValue([FormListName, name, "totals"], newTotalPrice.toFixed(3));

        if (type === "EDIT") {
            form.setFieldValue([FormListName, name], { ...form.getFieldsValue()[FormListName!][name], state: form.getFieldsValue()[FormListName!][name].id ? "update" : "insert" })
        }
        mergeIngredientDetail(ingredientLength, originData);
    }

    return (
        <>
            <Form.List name={formName}>
                {(fields, { add, remove }) => {
                    return (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <Space
                                    key={key}
                                    style={{ display: 'flex', marginBottom: 8 }}
                                    align="baseline"
                                >
                                    <Form.Item
                                        {...restField}
                                        // label="原材料"
                                        name={[name, 'productId']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入原材料',
                                            },
                                        ]}
                                    >
                                        <Select
                                            //optionLabelProp="label"
                                            style={{ width: 220 }}
                                            showSearch
                                            allowClear
                                            onSearch={(e) => getList.searchEx('product', setProductData, e, productData, {
                                                apiExtend: 'showListForIngredient',
                                                keyId: key,
                                                isFormList: true,
                                                form,
                                                FormListName: formName,
                                                name,
                                                andWhereObj: {
                                                    mountDataOptions: {
                                                        userMount: {
                                                            isDept: true
                                                        }
                                                    },
                                                }
                                            })}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData, 'productId')}
                                            placeholder="原材料"
                                            optionFilterProp="children"
                                            // filterOption={(input, option: any) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            filterOption={(input, option: any) => {
                                                // console.log("option",option);
                                                // console.log("input",input);
                                                return true
                                            }}
                                        >
                                            {getList.general(productData ? productData[key] ? productData[key] : [] : [], "productName")}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        // label="单位"
                                        name={[name, 'productUnitId']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入单位',
                                            },
                                        ]}
                                    >
                                        <Select
                                            style={{ width: 90 }}
                                            showSearch
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData, 'productUnitId')}
                                            placeholder="单位"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.generalEx(productUnitData, {
                                                itemName: "productUnitName",
                                                includeNull: false,
                                            })}
                                        </Select>

                                        {/* <Select
                                            //optionLabelProp="label"
                                            style={{ width: 90 }}
                                            showSearch
                                            allowClear
                                            onSearch={(e) => getList.searchEx('productUnit', setProductUnitData, e, productUnitData, {
                                                keyId: key,
                                                isFormList: true,
                                                form,
                                                FormListName: formName,
                                                name
                                            })}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="单位"
                                            optionFilterProp="children"
                                            // filterOption={(input, option: any) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}

                                            filterOption={(input, option: any) => {
                                                // console.log("option",option);
                                                // console.log("input",input);
                                                return true
                                            }}
                                        >
                                            {getList.general(productUnitData ? productUnitData[key] ? productUnitData[key] : [] : [], "productUnitName")}
                                        </Select> */}
                                    </Form.Item>

                                    <Form.Item
                                        // label="定量"
                                        {...restField}
                                        name={[name, 'amounts']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入定量',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{ width: 80 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="定量"
                                            min={0.001}
                                            step={0.001}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        // label="起率"
                                        {...restField}
                                        initialValue={100}
                                        name={[name, 'yieldRatio']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入起率',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{ width: 100 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="起率"
                                            min={0.01}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        // label="单价"
                                        {...restField}
                                        name={[name, 'unitPrice']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入单价',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{ width: 80 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="单价"
                                            min={0} />
                                    </Form.Item>

                                    <Form.Item
                                        // label="金额"
                                        {...restField}
                                        name={[name, 'totals']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入金额',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{ width: 80, color: "yellow" }}
                                            disabled
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="金额"
                                            min={0} />
                                    </Form.Item>

                                    <Form.Item
                                        // label="自动更新"
                                        {...restField}
                                        name={[name, 'autoUpdate']}
                                    >
                                        <Switch
                                            style={{ width: 110 }}
                                            defaultChecked
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            checkedChildren="单价自更新"
                                            unCheckedChildren="单价不自更新" />
                                    </Form.Item>

                                    <Form.Item
                                        // label="备注"
                                        {...restField}
                                        name={[name, 'memo']}
                                    >
                                        <Input
                                            style={{ width: 220 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="备注"
                                        />
                                    </Form.Item>

                                    <MinusCircleOutlined onClick={() => removeList(remove, name, key, tempDeleteData)} />
                                </Space>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => customizeAdd(add, ingredient, tempDeleteData)}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    添加
                                </Button>
                            </Form.Item>
                        </>
                    )
                }
                }
            </Form.List>
        </>
    )
}